import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-property-value',
  templateUrl: './property-value.component.html'
})
export class PropertyValueComponent implements OnInit {

  @Input() label: string;
  @Input() isList: boolean;
  @Input() value: string;

  // WORK WITH LIST
  @Input() items: Array<string>;
  @Input() sliceIn: number;
  @Input() emptyValueMessage: string;
  currentSlice: number;

  constructor() {
    this.isList = false;
    this.value = '';
    this.items = [];
    this.sliceIn = 10;
    this.emptyValueMessage = '';
  }
  
  ngOnInit(): void {
    this.currentSlice = this.sliceIn;
  }

  viewAll(): void {
    this.currentSlice = undefined;
  }

}
